<script lang="ts">
import { type InjectionKey } from 'vue'

export const FORM_ITEM_INJECTION_KEY
  = Symbol() as InjectionKey<string>
</script>

<script lang="ts" setup>
import { provide, useAttrs } from 'vue'
import { useId } from 'radix-vue'
import { cn } from '../../../lib/utils'

const props = defineProps<{
  id?: string;
}>();

defineOptions({
  inheritAttrs: false,
})

const id = props.id ?? useId()
provide(FORM_ITEM_INJECTION_KEY, id)

const { class: className, ...rest } = useAttrs()
</script>

<template>
  <div :class="cn('c-form-item flex flex-col items-start gap-4', className ?? '')" v-bind="rest">
    <slot />
  </div>
</template>

<style scoped>
@import '../../../assets/css/mixins/_mixins.index.pcss';

.c-form-item {
  @mixin body-small;
}
</style>
